import { useState } from "react";
import { TENANT_DOMAIN } from "../../../utils/domain";
import { ERROR_MESSAGES } from "../../../constant/constant";
import { useAxios } from "../../../utils/useAxios";
import { useAuth } from "../../../components/context/LoginContext/AuthContext";

/**
 * @typedef {object} UnreadCountData
 * @property {number} count - Number of unread notifications
 */

/**
 * Custom hook to fetch the unread notification count
 */
export const useGetUnreadCount = () => {
  const [unreadCount, setUnreadCount] = useState(undefined);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const { axiosInstance } = useAxios();
  const { fetchWithAuth } = useAuth();
  const apiUrl = process.env.REACT_APP_API_URL;

  const getUnreadCount = async ({ type } = {}) => {
    try {
      setLoading(true);
      setError("");

      const domain = type && type === "pcnormal" ? apiUrl : TENANT_DOMAIN;
      const url = `${domain}/notification/unread-count`;

      if (type && type === "pcnormal") {
        const raw = await fetchWithAuth(url, { method: "GET" });
        const parsed = await raw.json();
        setUnreadCount(parsed?.data?.count || null);
        return parsed?.data?.count || 0; //  return the count
      }

      const response = await axiosInstance.get(url);

      const count = response.data?.data?.count ?? 0;

      setUnreadCount(count);

      return count; // IMPORTANT
    } catch (err) {
      setUnreadCount(null);

      if (err?.response?.status === 500) {
        setError(ERROR_MESSAGES.INTERNAL_SERVER);
      } else {
        setError(err?.response?.data?.message || ERROR_MESSAGES.UNKNOWN);
      }

      return null; // handle error case
    } finally {
      setLoading(false);
    }
  };

  return {
    unreadCount,
    setUnreadCount,
    loading,
    error,
    getUnreadCount,
  };
};
